<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
    @update:open='updateOpen'
  )
    .krea-text-editor.column.relative(:style='{height: edition ? height : placeholderHeight}' v-if='edition || !value')
      tip-tap-editor(
        v-on-clickaway='blurTextEditor'
        v-if='edition'
        :value='value'
        :maxCharacters='maxCharacters'
        :errorMessage='errorMessage'
        :validations='validations'
        :height='height'
        :heading='!heading'
        :table='!table'
        :bold='!bold'
        :italic='!italic'
        :strike='!strike'
        :underline='!underline'
        :removeMarks='!removeMarks'
        :unorderedList='!unorderedList'
        :orderedList='!orderedList'
        :quote='!quote'
        :link='!linkOption'
        :removeLink='!removeLink'
        :image='!image'
        :video='!video'
        :undo='!undo'
        :redo='!redo'
        :preview='!preview'
        :fullscreen='!fullscreen'
        @input='onChange'
      )
      .placeholder.text-normal.dark-gray(v-else @click='focusInput' :style='setPlaceholderHeight') {{ placeholder }}
    .md-content(
      v-if='!edition && value'
      v-html='value'
      @click='focusInput'
      :class='{"md-small": small}'
    )
    template(slot="popover")
      actions(
        @edit='toggleEdition'
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :open='actionsOpen'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import TipTapEditor from '@/components/TipTap/TipTapEditor'
import kreaActions from '@/mixins/kreaActions'
import Actions from './Actions/Actions'

export default {
  mixins: [ clickaway, kreaActions ],
  components: { TipTapEditor, Actions },
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    maxCharacters: { type: Number },
    errorMessage: { type: String },
    validations: { type: Object },
    height: { type: String, default: '350px' },
    placeholderHeight: { type: String, default: '100%' },
    placeholder: { type: String },
    heading: { type: Boolean },
    bold: { type: Boolean },
    italic: { type: Boolean },
    strike: { type: Boolean },
    underline: { type: Boolean },
    table: { type: Boolean },
    removeMarks: { type: Boolean },
    unorderedList: { type: Boolean },
    orderedList: { type: Boolean },
    quote: { type: Boolean },
    linkOption: { type: Boolean },
    removeLink: { type: Boolean },
    image: { type: Boolean },
    video: { type: Boolean },
    undo: { type: Boolean },
    redo: { type: Boolean },
    preview: { type: Boolean },
    fullscreen: { type: Boolean },
    actionsPlacement: { type: String, default: 'top-end' },
    name: { type: String },
    small: { type: Boolean }
  },
  data() {
    return {
      edition: false,
      actionsOpen: false
    }
  },
  computed: {
    setPlaceholderHeight() {
      return {
        '--placeholder-height': this.placeholderHeight
      }
    }
  },
  methods: {
    blurTextEditor(evt) {
      if (!evt.target.className.includes('table-menu-item')) this.blurInput()
    },
    updateOpen(value) {
      this.actionsOpen = value
    },
    onChange(value) {
      this.$emit('input', value, this.name)
    },
    setEdition(value) {
      this.edition = value
      if (!this.edition) this.$emit('finishEdition')
    },
    focusInput() {
      this.setEdition(true)
    },
    blurInput() {
      this.setEdition(false)
    },
    toggleEdition() {
      this.edition = !this.edition
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors.scss';

.placeholder{
  background-color: $light-gray;
  padding: 10px;
  height: var(--placeholder-height);
  border-radius: 6px;
  cursor: text;
}
</style>
